export default __webpack_public_path__ + "static/media/promo-bundling-jpg.07c86136.jpg";